import { DocumentNode, QueryHookOptions, gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

export const queryCampaignFolderDetails = gql`
  query campaignFolderDetails($folderId: Long!) {
    campaignFolderDetails(folderId: $folderId) {
      id
      name
      ancestorIds
      subfolderIds
      contentIds
    }
  }
`;

type QueryCampaignFolderDetailsVariables = {
  folderId: number;
};

type QueryCampaignFolderDetailsResponse = {
  campaignFolderDetails: {
    id: number;
    name: string;
    ancestorIds: number[];
    subfolderIds: number[];
    contentIds: number[];
  };
};

type QueryCampaignFolderDetailsOptions = QueryHookOptions<
  QueryCampaignFolderDetailsResponse,
  QueryCampaignFolderDetailsVariables
>;

export const useCampaignFolderDetails = (
  options: QueryCampaignFolderDetailsOptions,
  query: DocumentNode = queryCampaignFolderDetails,
) => {
  const queryOptions: QueryCampaignFolderDetailsOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      skip: !options?.variables?.folderId,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql<QueryCampaignFolderDetailsResponse, QueryCampaignFolderDetailsVariables>(
    query,
    queryOptions,
  );

  return {
    campaignFolderDetails: data?.campaignFolderDetails,
    errorMessage,
    hasError,
    isLoading,
    refetch,
  };
};
